import {action, observable} from 'mobx';
import {databaseRef} from '../../helperFunctions/firebaseStore';
import {IUser} from '../storeInterfaces/authStoreInterface';
import {IOrder, IOrdersStore} from '../storeInterfaces/ordersStoreInterface';
import {IItem} from '../storeInterfaces/menuStoreInterface';

export const convertObjToArray = (obj: any) => {
    return obj ? Object.keys(obj).map(key => obj[key]) : [];
};

export class OrdersStore implements IOrdersStore {

    @observable
    orders: IOrder[] = [];
    @observable
    filteredOrders: IOrder[] = [];
    @observable
    loaded: boolean = false;
    @observable
    failed: boolean = false;

    @action
    updateOrderStatus = (orderId: string, status: string) => databaseRef.ref('/orders/' + orderId).update({orderStatus: status})

    @action
    filterOrders = (query: string) => {
        this.filteredOrders = this.orders.filter(o => o.user.name.toLowerCase().match(query.toLowerCase()) || o.user.phoneNumber.match(query));
    }

    @action
    async getOrders() {
        try {
            let snapshot = await databaseRef.ref('/users/').once('value');
            const oUsers: IUser[] = convertObjToArray(snapshot.val());
            snapshot = await databaseRef.ref('/items/').once('value');
            const oItems: IItem[] = convertObjToArray(snapshot.val());
            snapshot = await databaseRef.ref('/orders/').once('value');
            const oOrders: IOrder[] = convertObjToArray(snapshot.val());
            this.orders = oOrders.map(o => {
                const user = oUsers.filter(u => u.uid === o.userId)[0];
                const items = o.items.map(i => {
                    const item = oItems.filter(oItem => oItem.itemId === i.itemId);
                    return item ? {...i, item: item[0]} : undefined;
                }).filter(i => i !== undefined);
                const totalPrice = items.reduce((acc, item) => {
                    if(item){
                        const priceAfterDiscount = (item.item.price * ((100 - item.item.discount) / 100));
                        return acc + (priceAfterDiscount * item.quantity)
                    }
                    return acc;
                }, 0);
                return {...o, user, items, totalPrice};
            }).sort((a, b) => b.createdAt - a.createdAt) as IOrder[];
            this.filteredOrders = this.orders;
            this.loaded = true;
        } catch (e) {
            this.failed = true;
        }

    }
}